import { FC, useEffect, useState } from 'react';

import { Box, Image } from '@ui';

interface ImagePreviewProps {
  file: File;
}

const ImagePreview: FC<ImagePreviewProps> = ({ file }) => {
  const [fileObjectURL, setFileObjectURL] = useState('');
  useEffect(() => {
    if (file) {
      const objURL = URL.createObjectURL(file);
      setFileObjectURL(objURL);
    }
    return () => {
      fileObjectURL && URL.revokeObjectURL(fileObjectURL);
    };
  }, [file]);

  return (
    <Box>
      <Image
        src={fileObjectURL}
        alt="preview"
        w="100%"
        h="100%"
        style={{ objectFit: 'contain' }}
      />
    </Box>
  );
};

export default ImagePreview;
